export default "__VITE_ASSET__CThXqacD__"